export const SCHEDULING_METHOD_TYPES = {
  PHONE: "phone",
  EMAIL: "email",
  CALENDAR: "calendar",
} as const;

export const SCHEDULING_METHOD_VARIANTS = {
  VOICE_ONLY: "voice_only",
  TEXT_ONLY: "text_only",
  VOICE_AND_TEXT: "voice_and_text",
} as const;

export const SCHEDULING_METHOD_VARIANT_LABELS = {
  [SCHEDULING_METHOD_VARIANTS.TEXT_ONLY]: "Text only",
  [SCHEDULING_METHOD_VARIANTS.VOICE_AND_TEXT]: "Voice & text",
  [SCHEDULING_METHOD_VARIANTS.VOICE_ONLY]: "Voice only",
} as const;
